import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    MatCheckboxChange,
    MatCheckboxModule,
} from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ICustomHeaderParams } from '../../../../../core/models/grid/checkbox-header-renderer-params';

@Component({
    imports: [
        MatCheckboxModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatFormFieldModule,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './checkbox-header-renderer.component.html',
})
export class CheckboxHeaderRendererComponent implements IHeaderAngularComp {
    public params!: ICustomHeaderParams;

    agInit(params: ICustomHeaderParams): void {
        this.params = params;
    }

    onCheckboxChange(event: MatCheckboxChange) {
        if (this.params?.disabled) {
            return;
        }

        this.params.checkboxFunction?.(event);
    }

    onSortChanged() {}

    onSortRequested() {}

    refresh(_: IHeaderParams) {
        return true;
    }
}
